import React, { useMemo, useState, useEffect } from 'react';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classname from 'classnames';

import { landlordDetailTabs } from '~constants/landlord';
import { needShowTokenTab } from '~constants';
import { isLandlordRole } from '~helpers/auth';

export default function DetailLayout({
  children,
  activeTab,
  handleSetActiveTab,
  longtailPropertiesTotal,
}) {
  const { t } = useTranslation();
  const { currentRoleSlug } = useSelector(state => ({
    currentRoleSlug: state.auth?.toJS().auth.currentRoleSlug,
  }));
  const [showTokenTab, setShowTokenTab] = useState(needShowTokenTab.includes(currentRoleSlug));

  const handleLandlordTabs = useMemo(() => {
    let landlordTab = { ...landlordDetailTabs };
    // if (longtailPropertiesTotal === 0) {
    //   delete landlordTab.PAYMENTPLAN;
    // } else {
    //
    // }
    // landlordTab = { ...landlordTab, PAYMENTPLAN: 'PAYMENTPLAN' };
    if (!showTokenTab) {
      delete landlordTab.TOKEN;
    } else {
      landlordTab = { ...landlordTab, TOKEN: 'TOKEN' };
    }
    return Object.values(landlordTab);
  }, [currentRoleSlug, showTokenTab, longtailPropertiesTotal]);

  useEffect(() => {
    setShowTokenTab(needShowTokenTab.includes(currentRoleSlug));
  }, [currentRoleSlug]);

  return (
    <div className="layout-wrapper">
      <Menu
        onSelect={handleSetActiveTab}
        style={{ width: 248 }}
        defaultSelectedKeys={[landlordDetailTabs[activeTab]]}
        mode="inline"
      >
        <For of={handleLandlordTabs} each="tab" index="index">
          <If condition={tab === landlordDetailTabs.VERIFICATION}>
            <Choose>
              <When condition={activeTab === landlordDetailTabs.VERIFICATION}>
                <Menu.ItemGroup
                  key={landlordDetailTabs.VERIFICATION}
                  title={t(`cms.landlord.detail.${tab.toLowerCase()}.tab`)}
                  disabled={tab === landlordDetailTabs.CONTACT && isLandlordRole()}
                  className={classname({
                    'menu-group-active': activeTab === landlordDetailTabs.VERIFICATION,
                  })}
                >
                  <Menu.Item key={t('cms.landlord.verification.business_info')}>
                    {t('cms.landlord.verification.business_info')}
                  </Menu.Item>
                  <Menu.Item key={t('cms.landlord.verification.vetting_documentation')}>
                    {t('cms.landlord.verification.vetting_documentation')}
                  </Menu.Item>
                  <Menu.Item key={t('cms.landlord.verification.landlord_status')}>
                    {t('cms.landlord.verification.landlord_status')}
                  </Menu.Item>
                </Menu.ItemGroup>
              </When>
              <Otherwise>
                <Menu.Item
                  disabled={tab === landlordDetailTabs.CONTACT && isLandlordRole()}
                  key={landlordDetailTabs[tab]}
                >
                  {t(`cms.landlord.detail.${tab.toLowerCase()}.tab`)}
                </Menu.Item>
              </Otherwise>
            </Choose>
          </If>
          <If condition={tab !== landlordDetailTabs.VERIFICATION}>
            <Menu.Item
              disabled={tab === landlordDetailTabs.CONTACT && isLandlordRole()}
              key={landlordDetailTabs[tab]}
            >
              {t(`cms.landlord.detail.${tab.toLowerCase()}.tab`)}
            </Menu.Item>
          </If>
        </For>
      </Menu>
      <div className="layout-children">{children}</div>
    </div>
  );
}
